import { authPut } from "@api";

import { PolicyWithRules } from "@pages/policy/types";

export const savePolicy = (
  deploymentId: string,
  policy: PolicyWithRules
): Promise<PolicyWithRules> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policy.slug}`;
  return authPut<PolicyWithRules, PolicyWithRules>(path, policy);
};
